import { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, X, ArrowRight } from "lucide-react";
import { BookingCTA } from "./BookingCTA";

export function ChatWidget() {
  const [open, setOpen] = useState(false);
  const [messages] = useState([
    { role: "assistant", text: "G'day! I'm Westy from West Face Roofing 👋 Chasing a fast quote? Tap the button below and we'll get straight onto it — you'll hear from the team shortly." },
  ]);
  const endRef = useRef(null);

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, open]);

  return (
    <>
      <motion.button data-testid="chat-toggle" onClick={() => setOpen((v) => !v)}
        initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: 0.6, type: "spring" }}
        className="fixed bottom-5 right-5 z-[80] grid place-items-center w-[60px] h-[60px] rounded-full bg-[#62B848] text-white shadow-2xl shadow-[#62B848]/40 hover:bg-[#4E9B38] transition-colors">
        <AnimatePresence mode="wait">
          {open ? <motion.span key="x" initial={{ rotate: -90, opacity: 0 }} animate={{ rotate: 0, opacity: 1 }} exit={{ rotate: 90, opacity: 0 }}><X size={26} /></motion.span>
            : <motion.span key="c" initial={{ rotate: 90, opacity: 0 }} animate={{ rotate: 0, opacity: 1 }} exit={{ rotate: -90, opacity: 0 }}><MessageCircle size={26} /></motion.span>}
        </AnimatePresence>
      </motion.button>

      <AnimatePresence>
        {open && (
          <motion.div data-testid="chat-window" initial={{ opacity: 0, y: 24, scale: 0.96 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: 24, scale: 0.96 }}
            className="fixed bottom-24 right-5 z-[80] w-[calc(100vw-2.5rem)] sm:w-[380px] h-[540px] max-h-[70vh] bg-white rounded-3xl shadow-2xl border border-black/10 flex flex-col overflow-hidden">
            <div className="bg-[#224733] text-white px-5 py-4 flex items-center gap-3">
              <span className="grid place-items-center w-10 h-10 rounded-full bg-[#62B848] font-display font-extrabold">W</span>
              <div className="leading-tight">
                <div className="font-display font-bold">Westy · West Face</div>
                <div className="text-xs text-white/70 flex items-center gap-1.5"><span className="w-2 h-2 rounded-full bg-[#62B848] animate-pulse" /> Online · replies in seconds</div>
              </div>
            </div>

            <div className="flex-1 overflow-y-auto px-4 py-4 space-y-3 bg-[#F8F9FA]">
              {messages.map((m, i) => (
                <div key={i} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
                  <div className={`max-w-[82%] px-4 py-2.5 rounded-2xl text-sm leading-relaxed ${m.role === "user" ? "bg-[#224733] text-white rounded-br-md" : "bg-white border border-black/5 text-[#1A2421] rounded-bl-md"}`}>
                    {m.text}
                  </div>
                </div>
              ))}
              <div ref={endRef} />
            </div>

            <div className="p-3 border-t border-black/5 bg-white">
              <BookingCTA testId="chat-quote-btn"
                className="w-full flex items-center justify-center gap-2 rounded-full bg-[#62B848] hover:bg-[#4E9B38] text-white font-display font-bold py-3 text-sm transition-colors">
                Get a free quote <ArrowRight size={16} />
              </BookingCTA>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
